import Action from "./card-action.svelte"
import Content from "./card-content.svelte"
import Description from "./card-description.svelte"
import Footer from "./card-footer.svelte"
import Header from "./card-header.svelte"
import Title from "./card-title.svelte"
import Root from "./card.svelte"

export {
  Root,
  Content,
  Description,
  Footer,
  Header,
  Title,
  Action,
  //
  Root as Card,
  Content as CardContent,
  Description as CardDescription,
  Footer as CardFooter,
  Header as CardHeader,
  Title as CardTitle,
  Action as CardAction,
}
